
import { Badge, BadgeProps } from "@/components/ui/badge";
import { useDemoDetection } from "@/hooks/use-demo-detection";
import { cn } from "@/lib/utils";

interface DemoBadgeProps extends BadgeProps {
  showLabel?: boolean;
}

export function DemoBadge({ className, showLabel = true, ...props }: DemoBadgeProps) {
  const { isDemo, demoLabel } = useDemoDetection();
  
  if (!isDemo) return null;
  
  return (
    <Badge 
      variant="outline" 
      className={cn(
        "bg-yellow-100 text-yellow-800 border-yellow-300",
        className
      )}
      {...props}
    >
      {showLabel ? demoLabel : 'DEMO'}
    </Badge>
  );
}

export function DemoAccountBanner() {
  const { isDemo } = useDemoDetection();
  
  if (!isDemo) return null;
  
  return (
    <div className="bg-yellow-100 border-y border-yellow-300 text-yellow-800 px-4 py-2 text-sm text-center">
      ⚠️ Sie verwenden einen Demo-Account. Einige Funktionen sind eingeschränkt.
    </div>
  );
}
